<template>
  <Checkbox
    v-if="showComponent"
    :label="label"
    name="apiAuthorizeCheckbox"
    :checked="checked"
    :validation-errors="v$.value.checkedOption"
    @input="onFieldChange('checkedOption', $event)"
  />
</template>

<script>
import Checkbox from "../forms/SharedComponents/CheckBox.vue";
import formInputs from "../../mixins/formInputs";
import useVuelidate from "@vuelidate/core";
import { API_AUTHORIZE_TEXT, API_AUTHORIZE_CHECKBOX_SALESFORCE_SESSION_IDS } from "./constants";
import { sameAs } from "@vuelidate/validators";

export default {
  name: "ApiAuthorizeBox",
  components: { Checkbox },
  mixins: [formInputs],
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    salesforceId: {
      type: String,
      default: "",
    },
  },
  emits: ["update:api-authorize"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      value: {
        checkedOption: false,
      },
      label: API_AUTHORIZE_TEXT,
    };
  },
  computed: {
    showComponent() {
      return API_AUTHORIZE_CHECKBOX_SALESFORCE_SESSION_IDS.includes(this.salesforceId);
    },
  },
  watch: {
    value: {
      handler: function () {
        this.$emit("update:api-authorize", this.value);
      },
      deep: true,
      immediate: true,
    },
  },
  validations: {
    value: {
      checkedOption: {
        sameAs: sameAs(true),
      },
    },
  },
};
</script>
